/* lg-defer-img — load an image only when it is about to be seen.

   PDP-SPEED 16 Sep 2026 (docs/PDP-SPEED-2026-09-16.md). `loading="lazy"` is
   not enough on a phone: Chrome's lazy threshold on a slow connection is
   1,250–2,500px, so an 87 KB plate image half-way down the page was being
   fetched at ~1s and sharing the connection with the hero. Markup opts in:

     <img data-lg-defer data-src="…" data-srcset="…" src="<1px gif>" …>

   The srcset/src are copied across when the image comes within 400px of the
   viewport. No IntersectionObserver → everything is hydrated immediately, and
   the section carries a <noscript> copy for the no-JS case. */
(function () {
  if (window.__lgDeferImg) return;
  window.__lgDeferImg = true;

  function hydrate(img) {
    if (!img || !img.hasAttribute('data-lg-defer')) return;
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.src) img.setAttribute('src', img.dataset.src);
    img.removeAttribute('data-srcset');
    img.removeAttribute('data-src');
    img.removeAttribute('data-lg-defer');
  }

  function all() {
    return document.querySelectorAll('img[data-lg-defer]');
  }

  if (!('IntersectionObserver' in window)) {
    all().forEach(hydrate);
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      io.unobserve(e.target);
      hydrate(e.target);
    });
  }, { rootMargin: '400px 0px' });

  function observe() { all().forEach(function (img) { io.observe(img); }); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe);
  else observe();

  /* Sections added later (theme editor, dynamic loads) */
  document.addEventListener('shopify:section:load', observe);
})();
